"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreNumberFormatter = void 0;
const Currency_types_1 = require("../numbers/Currency.types");
class CoreNumberFormatter extends Intl.NumberFormat {
    constructor(locales, options) {
        super(locales, options);
        this.currencySymbols = new Map([
            ["AED", "\u0625\u002E\u062F"],
        ]);
    }
    format(value) {
        let formattedValue = super.format(value);
        const currency = this.resolvedOptions().currency;
        const currencyDisplay = this.resolvedOptions().currencyDisplay;
        const symbol = this.currencySymbols.get(currency);
        if (symbol !== undefined && Currency_types_1.CurrencyDisplay.SYMBOL == currencyDisplay) {
            const symbol = this.currencySymbols.get(currency);
            formattedValue = formattedValue
                .replace(/\p{Sc}|\b[A-Z]{3}\b/gu, symbol)
                .trim();
        }
        return formattedValue;
    }
}
exports.CoreNumberFormatter = CoreNumberFormatter;
//# sourceMappingURL=CoreNumberFormatter.js.map